import React from 'react';
import SelectPatient from './SelectPatient';
import { Link } from 'react-router-dom';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class NoProxy extends React.Component {
    constructor(props) {
        super(props);
        this.state = { checked: false };
        this.onChange = this.onChange.bind(this);
    }

    onChange(checked, value) {
        this.setState({ checked });
        const {onSkipProxy} = this.props;
        if(onSkipProxy)
        {
            onSkipProxy(checked);
        }
    }

    actionTaken = (event, dependent) => {        
        const { checked } = this.state;
        const { savePreferenceCall, onActionTaken , activityCode} = this.props;
        if (dependent && activityCode) {           
            logUI(activityCode, new Date(), Tools.getURLPath());
        }
        if (checked && savePreferenceCall)
        {
            savePreferenceCall();            
            if(onActionTaken)
                onActionTaken(true);
        }
    }

    render() {
        const { myProxies, message, fromEvisit, currentUser, switchToMyChartUser, location, backToCalender, skipPatientInfo, stepHeading, titleInfo, iconLeftClass, iconRightClass, savePreferenceCall, removeActive, steptitle, goNext, serverData, isMammography, goToApptInfo, apptInfoStepValue, enableNewServiceSchedulingWorkflow,goToNewStep, reasonSubmitStepValue, enableNewProviderSchedulingWorkflow, apptSlotNotAvailable, apptTimeNotAvailable, isFromDotCOM, hasMychart } = this.props;
        return (<div className="no-proxy-container" style={this.props.style}>
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <SelectPatient message={message} myProxies={myProxies} location={location} skipPatientInfo={skipPatientInfo} backToCalender={backToCalender} currentUser={currentUser} switchToMyChartUser={switchToMyChartUser} isMammography={isMammography}
                            fromEvisit={fromEvisit} onClicked={this.actionTaken} iconLeftClass={iconLeftClass} removeActive steptitle={steptitle} goNext={goNext} hasMychart={hasMychart}
                            className={"col-12 col-lg-6"} serverData={serverData} newUserSelected={this.props.newUserSelected} onUserSelected={this.props.onUserSelected} goToApptInfo={goToApptInfo} apptTimeNotAvailable={apptTimeNotAvailable} isFromDotCOM={isFromDotCOM}
                            apptInfoStepValue={apptInfoStepValue} goToNewStep={goToNewStep} reasonSubmitStepValue={reasonSubmitStepValue} enableNewProviderSchedulingWorkflow={enableNewProviderSchedulingWorkflow} apptSlotNotAvailable={apptSlotNotAvailable}  enableNewServiceSchedulingWorkflow={enableNewServiceSchedulingWorkflow}
                        />
                        <div className="no-proxy-add-dependents col-12 col-lg-6">
                            <div className="hr-divider d-block d-lg-none"></div>
                            <div className="row text-center no-proxy-add-dependents__body">
                                <div className="col-12 text-center">
                                    <div className="title">
                                        <div className={iconRightClass || 'svg-dependent'}></div>
                                            <h1 className="step-heading">{stepHeading}</h1>
                                        </div>
                                        <div className="title-info mb-4">{titleInfo}</div>
                                    </div>
                                <div className="col-12 select-patient-list">
                                    <div className="form-group"><Link className={`btn btn-primary`} to={{ pathname: "/proxyrequestDOB", searchParams: "fromNoProxy=true" }} onClick={(e) => { this.actionTaken(e, "dependent"); }}><span className="icon-new"></span> ADD A DEPENDENT</Link></div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    {fromEvisit && <div className="row">
                        <div className="no-proxy-add-dependents col-12 col-lg-6 offset-lg-6">
                            <div className="row msg-info">
                                <div className="col-12">
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <span className="icon-info-filled" />
                                        </div>
                                        <div className="details-col">
                                            <p>Minor must be an existing patient of Baylor Scott and White Health.</p>
                                            <p>Approval process may take up to 1 business day.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            {!isMammography && (
                <div className="row text-center">
                    <div className="col-12 maxWidth-content">
                        <label className="checkbox-container">
                            <input type="checkbox" name="proxy-dependents" checked={this.state.checked} onChange={e => this.onChange(e.target.checked)} />
                            <span className="checkmark" />
                            <span className="checkbox-label"> Skip this question in the future</span>
                        </label>
                    </div>
                </div>
            )}
        </div>);
    }

}


export default NoProxy;